// Generated types for FunctionalModule
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionDefinitionReadAPI, ActionDefinitionWriteAPI } from '../../sysml/types/actiondefinition';
import { ActionDefinitionReadAPISchemaObject, ActionDefinitionWriteAPISchemaObject } from '../../sysml/types/actiondefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FunctionalModuleReadAPI extends ActionDefinitionReadAPI {
}

export interface FunctionalModuleWriteAPI extends ActionDefinitionWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FunctionalModuleReadAPISchema: z.ZodType<FunctionalModuleReadAPI> = ActionDefinitionReadAPISchemaObject.extend({}).passthrough();

export const FunctionalModuleWriteAPISchema: z.ZodType<FunctionalModuleWriteAPI> = ActionDefinitionWriteAPISchemaObject.extend({}).passthrough();
